// extracted by mini-css-extract-plugin
export default {"footerContainer":"baseBunchInvoicesForm_footerContainer__GL367","button":"baseBunchInvoicesForm_button__a6mph","secondGroup":"baseBunchInvoicesForm_secondGroup__+2lyO"};